<template>
  <div class="vg-picker">
    <div class="itme">
      <div class="item-label">出入证类型：</div>
      <van-field class="item-input" placeholder="请选择电子出入证类型" input-align="left" readonly  v-model="valueText" @click="onClick" is-link />
<!--      <div class="itme-content" @click="onClick">-->
<!--        <input class="item-input" :value="valueText" placeholder="请选择电子出入证类型" readonly>-->
<!--        <van-image width="18" height="18" :src="srcArrow"/>-->
<!--      </div>-->
    </div>
    <van-popup :value="show" position="bottom" class="vantPopup" @input="onCancel">
      <van-picker
          show-toolbar
          title="出入证类型"
          :columns="columns"
          @confirm="onConfirm"
          @cancel="onCancel"/>
    </van-popup>
  </div>
</template>

<script>

import { Picker, Popup, Field} from "vant";
import srcArrow from "@/assets/right_arrow.svg";

export default {
  name: "PassCardTypePicker",
  components: {
    //VanImage,
    "van-picker": Picker,
    "van-popup": Popup,
    "van-field": Field
  },
  props: {
    label: String,
    value: null,
    disabled: Boolean,
  },
  watch: {
    value(newValue) {
      if (!newValue) {
        this.input(this.columns[0].value)
      }
    }
  },
  data() {
    return {
      srcArrow: srcArrow,
      show: false,
      columns: [
        {
          text: '全部',
          value: ''
        },
        {
          text: '物业服务商施工',
          value: 'CONSTRUCTION_SERVICE_PROVIDER'
        },
        {
          text: '装修单元施工',
          value: 'CONSTRUCTION_DECORATION'
        },
        {
          text: '营运单元施工',
          value: 'CONSTRUCTION_OPERATIONS'
        },
        {
          text: '租户员工',
          value: 'TENANT_EMPLOYEE'
        },
        {
          text: '货品进出单',
          value: 'GOODS_IN_OUT'
        }
      ],
    }
  },
  computed: {
    valueText() {
      return this.columns.find(column => column.value === this.value)?.text;
    },
    currentColumn() {
      return this.columns.find(column => column.value === this.value);
    }
  },
  methods: {
    onClick() {
      this.show = true;
    },
    input(value) {
      this.$emit('input', value)
    },
    onConfirm(column) {
      this.input(column.value);
      this.show = false;
    },
    onCancel() {
      this.show = false;
    }
  }
}
</script>

<style scoped>
.vg-picker {
  //background-color: #FFFFFF;
  padding: 15px 15px 5px 15px;
}

.itme {
  //padding: 15px 15px 5px 15px;
  //padding: 10px 10px 5px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: stretch;
  //background-color: #FFFFFF;
  //border-radius: 5px;
  //box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.11)
}

.item-label {
  font-size: 16px;
  color: #000000;
  width:40%;
}

.itme-content {
  padding: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  border: 0.1px solid #BBBBBB;
  flex-grow: 1;

}

.item-input {
  background-color: #bbbbbb00;
  font-size: 16px;
  color: #000000;
  border: 0.1px solid #BBBBBB;
  border-radius: 5px;
  padding: 3px;
  width: 100%;
}

.itme-content input::placeholder {
  color: #BBBBBB;
}

</style>
